export default __webpack_public_path__ + "static/naturalwomen-b4794a63c0fadb71ee83c70e1ac786d2.jpg";